console.log("==== Global Functions Loaded ==== ");

const CART_UPDATE_EVENT_DISPATCHER = "wetheme-cart-update";
const updateCartSlider = (cart) => {
  const event = new CustomEvent(CART_UPDATE_EVENT_DISPATCHER, {
    detail: {
      cart,
    },
  });
  document.documentElement.dispatchEvent(event);
};

const createModal = ({
  title,
  content,
  closeButton,
  confirmButton,
  cancelButton,
}) => {
  if (!title || !content) {
    throw new Error("Missing Modal arguments");
  }
  const modalID = "modal-" + stringToHash(title);
  const alreadyExists = document.querySelector(`.global-modal-container`);
  if (alreadyExists) {
    console.log("Modal already exists");
    return;
  }

  function closeModal(modalID) {
    document.querySelector(`#${modalID}`).remove();
    document.querySelector("body").classList.remove("body-stop-scrolling");
  }

  const modalContainer = document.createElement("div");
  modalContainer.id = modalID;
  modalContainer.classList.add("global-modal-container");
  modalContainer.innerHTML = `
    <div class="global-modal-wrapper">
        ${closeButton
      ? `<button class="global-modal-close"><i class="fa-solid fa-xmark"></i></button>`
      : ""
    }
        <h3 class="global-modal-title">${title}</h3>
        <div class="global-modal-content">
            ${content}
        </div>
        <div class="global-modal-btn-wrapper">
        ${cancelButton
      ? `<button class="global-modal-cancel">Cancel</button>`
      : ""
    }
        ${confirmButton
      ? `<button class="global-modal-confirm">${confirmButton.text}</button>`
      : ""
    }
        </div>
    </div>
  `;
  document.querySelector("body").classList.add("body-stop-scrolling");
  document.querySelector("body").appendChild(modalContainer);
  if (closeButton) {
    document
      .querySelector(`#${modalID} button.global-modal-close`)
      .addEventListener("click", () => {
        closeModal(modalID);
      });
  }
  if (confirmButton) {
    document
      .querySelector(`#${modalID} button.global-modal-confirm`)
      .addEventListener("click", async (e) => {
        e.disabled = true;
        e.target.innerHTML = `<i class="fas fa-circle-notch fa-spin"></i>`;
        await confirmButton.action();
        closeModal(modalID);
      });
  }
  if (cancelButton) {
    document
      .querySelector(`#${modalID} button.global-modal-cancel`)
      .addEventListener("click", () => {
        closeModal(modalID);
      });
  }
};
const stringToHash = (string) => {
  var hash = 0;
  if (string.length == 0) return hash;
  for (i = 0; i < string.length; i++) {
    char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
};

const createToast = ({ type, message, debug }) => {
  const typeAssets = {
    success: `<i class="fa-regular fa-circle-check"></i>`,
    error: `<i class="fa-solid fa-circle-exclamation"></i>`,
    alert: `<i class="fa-solid fa-bell"></i>`,
    announcement: `<i class="fa-solid fa-bullhorn"></i>`,
  };
  // Component Checkers
  if (!type || !message) throw "Toast Component missing arguments";
  if (typeAssets[type] === undefined) throw "Toast Type not defined";

  const container = document.createElement("div");
  const id = "id-" + stringToHash(message);
  container.id = id;
  container.classList.add("global-toast-container");
  container.innerHTML = `
    <div class="global-toast-wrapper ${type}">
      <div class="global-toast-title-block">
        <div class="global-toast-icon">${typeAssets[type]}</div>
        <p class="global-toast-title">${message.toLowerCase()}</p>
      </div>
    </div>
  `;

  document.querySelector("body").appendChild(container);
  container.addEventListener("animationend", (e) => {
    console.log(e);
    if (e.animationName === "fadeOut") {
      !debug && container.remove();
    }
  });
};

/* ======= CART HANDLERS ======= */
const fetchCart = async () => {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) {
      throw { error: res };
    }
    const cart = await res.json();
    return cart;
  } catch (error) {
    throw error;
  }
};
const fullClearCart = async () => {
  try {
    await clearCartItems();
    const emptyCart = await clearCartAttrAndNotes();
    return emptyCart;
  } catch (error) {
    throw error;
  }
};
const clearCartItems = async () => {
  try {
    const res = await fetch("/cart/clear.js");
    if (!res.ok) {
      throw { error: res };
    }
    const cart = await res.json();
    updateCartSlider(cart);
    return cart;
  } catch (error) {
    throw error;
  }
};
const clearCartAttrAndNotes = async () => {
  try {
    const cart = await fetchCart();
    const newCartAttr = {};
    for (const attr in cart.attributes) {
      newCartAttr[attr] = null;
    }
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;",
      },
      body: JSON.stringify({
        notes: "",
        attributes: newCartAttr,
      }),
    });
    const updatedCart = await res.json();
    return updatedCart;
  } catch (error) {
    throw error;
  }
};


const fetchProductJSON = async function (handle) {
  const res = await fetch("/products/" + handle + ".js");
  if (!res.ok) return { error: res };
  const data = await res.json();
  return data;
};
const fetchSection = async (sectionID) => {
  const res = await fetch("/?sections=" + sectionID);
  if (!res.ok) return { error: res };
  const body = await res.json();
  const section_body = body[sectionID];
  return new DOMParser()
    .parseFromString(section_body, "text/html")
    .querySelector(".shopify-section");
};


const scrollToElement = () => {
  const elements = document.querySelectorAll("[data-smooth-scroll-to]");
  elements.forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.querySelector(
        e.target.getAttribute("data-smooth-scroll-to")
      );
      target.scrollIntoView({
        behavior: "smooth",
      });
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  scrollToElement();
})